import React from "react";

import { ANCHORS, CONTACT } from "../../data/content";

//FAQ with Events / General Information / Accommodation tabs, and questions that open one at a time (as on Wix)
const Faq = () => {
  const [tab, setTab] = React.useState(0);
  const [openQ, setOpenQ] = React.useState(null);
  const tabRefs = React.useRef([]);

  const selectTab = (i) => {
    setTab(i);
    setOpenQ(null);
  };

  //Arrow keys move between tabs (WAI-ARIA tabs pattern)
  const onTabKeyDown = (e) => {
    const count = CONTACT.FAQ.length;
    let next = null;
    if (e.key === "ArrowRight") {
      next = (tab + 1) % count;
    }
    else if (e.key === "ArrowLeft") {
      next = (tab - 1 + count) % count;
    }
    else if (e.key === "Home") {
      next = 0;
    }
    else if (e.key === "End") {
      next = count - 1;
    }
    if (next !== null) {
      e.preventDefault();
      selectTab(next);
      tabRefs.current[next].focus();
    }
  };

  const group = CONTACT.FAQ[tab];

  return (
    <section
      id={ANCHORS.FAQ}
      className={"faq"}
      aria-labelledby={"faq-title"}
    >
      <div className={"faq-card"}>
        <h2
          id={"faq-title"}
          className={"faq-title"}
        >
          {CONTACT.FAQ_TITLE}
        </h2>

        <div
          className={"faq-tabs"}
          role={"tablist"}
          aria-label={"FAQ topics"}
        >
          {CONTACT.FAQ.map((g, i) => (
            <button
              key={g.tab}
              ref={(el) => (tabRefs.current[i] = el)}
              type={"button"}
              role={"tab"}
              id={`faq-tab-${i}`}
              aria-selected={i === tab}
              aria-controls={"faq-panel"}
              tabIndex={i === tab ? 0 : -1}
              className={`faq-tab ${i === tab ? "is-active" : ""}`}
              onClick={() => selectTab(i)}
              onKeyDown={onTabKeyDown}
            >
              {g.tab}
            </button>
          ))}
        </div>

        <div
          id={"faq-panel"}
          role={"tabpanel"}
          aria-labelledby={`faq-tab-${tab}`}
        >
          {group.items.map((item, i) => {
            const isOpen = openQ === i;
            const id = `faq-${tab}-${i}`;
            return (
              <div
                key={item.q}
                className={`faq-item ${isOpen ? "is-open" : ""}`}
              >
                <h3 className={"faq-question"}>
                  <button
                    type={"button"}
                    aria-expanded={isOpen}
                    aria-controls={id}
                    onClick={() => setOpenQ(isOpen ? null : i)}
                  >
                    <span>{item.q}</span>
                    <svg
                      viewBox={"0 0 16 9"}
                      aria-hidden={"true"}
                      focusable={"false"}
                    >
                      <path
                        d={"M1 1l7 7 7-7"}
                        fill={"none"}
                        stroke={"currentColor"}
                        strokeWidth={"1.3"}
                      />
                    </svg>
                  </button>
                </h3>
                <div
                  id={id}
                  className={"faq-answer"}
                  hidden={!isOpen}
                >
                  {item.a.map((p) => (
                    <p key={p}>{p}</p>
                  ))}
                  {item.list ? (
                    <ul>
                      {item.list.map((li) => (
                        <li key={li}>{li}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
